module.exports = __webpack_public_path__ + "img/ic_star_off.0c0e47d5.svg";